import * as React from 'react';
import { Box, Card, Collapse, Container, Text, TextButton } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { ChevronUp, ChevronDown } from 'wix-ui-icons-common';
import { RefObject } from 'react';
import { Actions } from '@src/context/actions/actions';
import { KBLinks } from '@src/constants';
import { ReviewCookieCheckbox } from './review-cookie-checkbox';
import { ReviewCookieCollapsedContent } from './review-cookie-collapsed-content';

export interface ReviewPolicyProps extends InjectedTranslateProps, Pick<Actions, 'setSaveStatus'> {
  hasError: boolean;
  updateCookiePolicyRequirement(requirementApproved: boolean): void;
  cookiePolicyRequirementApproved: boolean;
  kbLinks: KBLinks;
}
export interface State {
  showMoreOpened: boolean;
  scrolledToView: boolean;
}

class InnerReviewCookiePolicyRequirements extends React.PureComponent<ReviewPolicyProps, State> {
  innerRef: RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();
  state: State = {
    showMoreOpened: false,
    scrolledToView: false,
  };

  renderShowMoreButton = () => {
    const { t } = this.props;
    const { showMoreOpened } = this.state;
    const text = t(showMoreOpened ? 'review.cookie.policy.show.less' : 'review.cookie.policy.show.more');
    const suffixIcon = showMoreOpened ? <ChevronUp /> : <ChevronDown />;

    return (
      <TextButton
        dataHook={DataHooks.ReviewCookiePolicyRequirementsShowMore}
        suffixIcon={suffixIcon}
        onClick={this.toggleShowMore}
      >
        {text}
      </TextButton>
    );
  };

  componentDidUpdate(): void {
    if (!this.state.scrolledToView) {
      const current = this.innerRef.current;
      if (current && current.scrollIntoView) {
        current.scrollIntoView();
      }
      this.setState({
        scrolledToView: true,
      });
    }
  }

  toggleShowMore = () => {
    this.setState((prevState) => ({
      showMoreOpened: !prevState.showMoreOpened,
    }));
  };

  render() {
    const { t, hasError, updateCookiePolicyRequirement, cookiePolicyRequirementApproved, kbLinks } = this.props;
    const { showMoreOpened } = this.state;
    return (
      <div ref={this.innerRef}>
        <Container>
          <Card dataHook={DataHooks.ReviewCookiePolicyRequirementsContainer}>
            <Card.Header
              dataHook={DataHooks.ReviewCookiePolicyRequirementsHeader}
              title={t('review.cookie.policy.title')}
            />
            <Card.Divider />
            <Card.Content>
              <Box direction={'vertical'}>
                <Box>
                  <Text dataHook={DataHooks.ReviewCookiePolicyRequirementsDescription}>
                    {t('review.cookie.policy.description')}
                  </Text>
                </Box>
                {this.renderShowMoreButton()}
                <Collapse open={showMoreOpened}>
                  <Box dataHook={DataHooks.ReviewCookiePolicyRequirementsContent}>
                    <ReviewCookieCollapsedContent kbLinks={kbLinks} />
                  </Box>
                </Collapse>
                <Box marginTop={'12px'} marginBottom={'18px'}>
                  <Card.Divider />
                </Box>
                <ReviewCookieCheckbox
                  hasError={hasError}
                  dataHook={DataHooks.ReviewCookiePolicyRequirementsCheckbox}
                  initialState={cookiePolicyRequirementApproved}
                  onChange={updateCookiePolicyRequirement}
                >
                  {t('review.cookie.policy.checkbox')}
                </ReviewCookieCheckbox>
              </Box>
            </Card.Content>
          </Card>
        </Container>
      </div>
    );
  }
}

export const ReviewCookiePolicyRequirementsComponent = translate()(InnerReviewCookiePolicyRequirements);
